import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'InputCustomFieldFormController',
            InputCustomFieldFormController
        );

    function InputCustomFieldFormController() {
        var vm = this;

        init();

        function init() {}
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/custom_fields/input/input.controller.ts